module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account--wrapper warehouse-item-editor"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-push-4 col-md-4"
  }, [_c('div', {
    staticClass: "card ui-card form--account"
  }, [_c('H1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (!_vm.loaded) ? _c('my-loader') : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('button', {
    staticClass: "tile tile--pos warehouse-item-editor__preview"
  }, [_c('div', {
    staticClass: "tile-top"
  }, [_c('div', {
    staticClass: "tile-name"
  }, [_vm._v(_vm._s(_vm.getCompanyInfoName(_vm.model)))]), _vm._v(" "), (_vm.model.addInfo != null && _vm.model.addInfo.currency != null) ? _c('div', {
    staticClass: "tile-price"
  }, [_vm._v("\n                  " + _vm._s(_vm.money(_vm.model.price, _vm.model.addInfo.currency)) + "\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.model.locations != null && (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN')) ? _c('p', [_c('i', {
    staticStyle: {
      "color": "#6760EE"
    }
  }, [_vm._v(_vm._s(_vm.model.locations))])]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "product-image warehouse-item-editor__image",
    attrs: {
      "src": _vm.model.imageMain,
      "alt": "product image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tile-bottom"
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.stockClass(_vm.model)
  }, [_vm._v(_vm._s(_vm.stockLabel(_vm.model)))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_stock_number')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stockNumber),
      expression: "stockNumber"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_stock_number')
    },
    domProps: {
      "value": (_vm.stockNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stockNumber = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_save')) + "\n                  ")])])])]), _vm._v(" "), _c('br')], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-package"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-721ea148!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Warehouse/AddEditWarehouseShopItem.vue
// module id = 788
// module chunks = 0